import { formatCents } from '@src/common';
import { CartItem as CartItemType } from '@src/core/buyerApiClient';
import useTranslate from '@src/i18n/useTranslate';
import React from 'react';
import CartItem from '../Summary/CartSummary/CartItem';
import {
  PackageDiscountValue,
  PackageOriginalPrice,
  PackagePriceInfo,
  PackagePrices,
  PackageTotalPrice,
} from './styles';

interface SaleItemComponentProps {
  item: CartItemType;
  showPlaceholderImage?: boolean;
}

export const CartPackageItemDetail: React.FC<SaleItemComponentProps> = ({ item, showPlaceholderImage = false }) => {
  const { i18n } = useTranslate();

  return (
    <CartItem showPlaceholderImage={showPlaceholderImage} key={item.id} item={item}>
      <PackagePrices>
        <PackagePriceInfo>
          {i18n('cart_package_previous_price')}
          <PackageOriginalPrice>{formatCents(item.costPreview.totalPriceCents)}</PackageOriginalPrice>
        </PackagePriceInfo>

        <PackagePriceInfo>
          {i18n('cart_package_discount')}
          <PackageDiscountValue>-{formatCents(item.costPreview.packageDiscountCents)}</PackageDiscountValue>
        </PackagePriceInfo>

        <PackagePriceInfo>
          {i18n('cart_package_total')}
          <PackageTotalPrice>
            {formatCents(item.costPreview.totalPriceCents - item.costPreview.packageDiscountCents)}
          </PackageTotalPrice>
        </PackagePriceInfo>
      </PackagePrices>
    </CartItem>
  );
};

export default CartPackageItemDetail;
